import React, { useState } from 'react';
import { useExportReport } from '../../hooks/useReports';
import type { ReportFilter } from '../../types';

interface ExportButtonsProps {
  reportType: 'category' | 'time';
  filters: ReportFilter;
  disabled?: boolean;
}

const ExportButtons: React.FC<ExportButtonsProps> = ({
  reportType,
  filters,
  disabled = false,
}) => {
  const [isExporting, setIsExporting] = useState(false);
  const exportMutation = useExportReport();

  const handleExport = async (format: 'excel' | 'pdf') => {
    setIsExporting(true);
    try {
      const result = await exportMutation.mutateAsync({
        reportType,
        format,
        filters,
        includeCharts: true,
      });

      // Create a temporary anchor element to trigger download
      const link = document.createElement('a');
      link.href = result.downloadUrl;
      link.target = '_blank';
      link.rel = 'noopener noreferrer';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } catch (error) {
      console.error('Error exporting report:', error);
    } finally {
      setIsExporting(false);
    }
  };

  return (
    <div className="flex flex-col sm:flex-row gap-2">
      <button
        onClick={() => handleExport('excel')}
        disabled={disabled || isExporting}
        className="px-4 py-2 text-sm font-medium text-white bg-green-600 hover:bg-green-700 disabled:bg-gray-400 disabled:cursor-not-allowed rounded-md transition-colors flex items-center justify-center gap-2"
      >
        <svg
          className="w-5 h-5"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M12 10v6m0 0l-3-3m3 3l3-3m2 8H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
          />
        </svg>
        {isExporting ? 'Exportando...' : 'Exportar Excel'}
      </button>

      <button
        onClick={() => handleExport('pdf')}
        disabled={disabled || isExporting}
        className="px-4 py-2 text-sm font-medium text-white bg-red-600 hover:bg-red-700 disabled:bg-gray-400 disabled:cursor-not-allowed rounded-md transition-colors flex items-center justify-center gap-2"
      >
        <svg
          className="w-5 h-5"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M7 21h10a2 2 0 002-2V9.414a1 1 0 00-.293-.707l-5.414-5.414A1 1 0 0012.586 3H7a2 2 0 00-2 2v14a2 2 0 002 2z"
          />
        </svg>
        {isExporting ? 'Exportando...' : 'Exportar PDF'}
      </button>
    </div>
  );
};

export default ExportButtons;
